import type { App } from 'vue';
import { createI18n } from 'vue-i18n';

import messages from 'src/i18n';
import { APP_LANGUAGE_KEY } from 'src/stores/userInterfaceSettings/localStorageKeys';
import { type AppLanguage } from 'src/stores/userInterfaceSettings/state';

import { setDateLocale } from 'src/util/date';
import { resolveLocaleForLanguagePreference } from 'src/util/locale';

interface GlobalI18n {
	locale: { value: string };
	t: (key: string, named?: Record<string, unknown>) => string;
}

let globalI18n: GlobalI18n | null = null;

export function translateKey(key: string, named?: Record<string, unknown>): string {
	if (globalI18n === null) {
		return key;
	}

	if (named !== undefined) {
		return globalI18n.t(key, named);
	}

	return globalI18n.t(key);
}

export function setAppLocale(locale: string): void {
	if (globalI18n !== null) {
		globalI18n.locale.value = locale;
	}

	setDateLocale(locale);
}

export async function bootI18n({ app }: { app: App<Element> }): Promise<void> {
	const storedLanguage = localStorage.getItem(APP_LANGUAGE_KEY);
	const languagePreference: AppLanguage =
		storedLanguage === 'de' || storedLanguage === 'en' ? storedLanguage : 'system';
	const locale = await resolveLocaleForLanguagePreference(languagePreference);

	const i18n = createI18n({
		globalInjection: true,
		legacy: false,
		locale,
		messages,
		warnHtmlMessage: false,
	});
	app.use(i18n);
	globalI18n = i18n.global as unknown as GlobalI18n;

	setDateLocale(locale);
}
